export const FEATURE_FACE_RECOGNITION = 'FACE_RECOGNITION' as const;
export const FEATURE_WILDMOKA_TRANSCODER = 'WILDMOKA_TRANSCODER' as const;
export const FEATURE_PLAYING_ORIGINAL_DURING_TRANSCODING =
  'PLAYING_ORIGINAL_DURING_TRANSCODING' as const;
export const FEATURE_UNIFIED_PLAYER_PDF_OPT_OUT =
  'UNIFIED_PLAYER_PDF_OPT_OUT' as const;
export const FEATURE_MULTI_CHANNEL_AUDIO = 'MULTI_CHANNEL_AUDIO' as const;
export const FEATURE_NEW_TRANSFER_API = 'NEW_TRANSFER_API' as const;
export const FEATURE_ICONIK_DESKTOP_PLAYER = 'ICONIK_DESKTOP_PLAYER' as const;
export const FEATURE_WM_PUBLISH_PANEL = 'WM_PUBLISH_PANEL' as const;
export const FEATURE_ISG_PRO = 'ISG_PRO' as const;
export const FEATURE_ISG_GATEWAYS_TAB = 'ISG_GATEWAYS_TAB' as const;
export const FEATURE_EDGE_TRANSCODER = 'EDGE_TRANSCODER' as const;
export const FEATURE_REMOTE_PROXIES = 'REMOTE_PROXIES' as const;
export const FEATURE_ICONIK_SHIELD = 'ICONIK_SHIELD' as const;
export const FEATURE_NATURAL_LANGUAGE_TO_FILTERS =
  'NATURAL_LANGUAGE_TO_FILTERS' as const;
export const FEATURE_NATURAL_SEARCH = 'NATURAL_SEARCH' as const;
export const FEATURE_NATURAL_SEARCH_SEGMENTS =
  'NATURAL_SEARCH_SEGMENTS' as const;
export const FEATURE_AI_METADATA_ENRICHMENT = 'METADATA_AI_FILLING' as const;
export const FEATURE_AI_METADATA_ENRICHMENT_AUTOMATION =
  'AI_METADATA_ENRICHMENT_AUTOMATION' as const;
export const FEATURE_SEARCH_BACKENDS = 'SEARCH_BACKENDS' as const;
export const FEATURE_MCP_SERVER = 'MCP_SERVER' as const;
export const FEATURE_CUTTING_ROOM = 'CUTTING_ROOM' as const;
export const FEATURE_IOS_SYNC = 'IOS_SYNC' as const;
export const FEATURE_DRM_FORENSIC_WATERMARK = 'DRM_FORENSIC_WATERMARK' as const;
export const FEATURE_WM_PUBLISH_SUPPORTS_TRANSFER_AND_PUBLISH =
  'WM_PUBLISH_SUPPORTS_TRANSFER_AND_PUBLISH' as const;

export const FEATURE_PORTALS = 'PORTALS' as const;
export const FEATURE_PDF_CLICKABLE_LINKS = 'PDF_CLICKABLE_LINKS' as const;
export const FEATURE_WILDMOKA_REPLACES_FFMPEG =
  'WILDMOKA_REPLACES_FFMPEG' as const;
export const FEATURE_SCIM = 'SCIM' as const;

export const FEATURE_TOGGLE_OPTIONS = [
  { label: 'Face Recognition', value: FEATURE_FACE_RECOGNITION },
  { label: 'Wildmoka Transcoder', value: FEATURE_WILDMOKA_TRANSCODER },
  {
    label: 'Playing Original Files',
    value: FEATURE_PLAYING_ORIGINAL_DURING_TRANSCODING,
  },
  { label: 'Old Player PDF', value: FEATURE_UNIFIED_PLAYER_PDF_OPT_OUT },
  { label: 'Multi-channel Audio', value: FEATURE_MULTI_CHANNEL_AUDIO },
  { label: 'New Transfer API', value: FEATURE_NEW_TRANSFER_API },
  { label: 'Iconik Desktop Player', value: FEATURE_ICONIK_DESKTOP_PLAYER },
  { label: 'WM Publish Panel', value: FEATURE_WM_PUBLISH_PANEL },
  { label: 'ISG Pro', value: FEATURE_ISG_PRO },
  { label: 'ISG Gateways Tab', value: FEATURE_ISG_GATEWAYS_TAB },
  { label: 'Edge Transcoder', value: FEATURE_EDGE_TRANSCODER },
  { label: 'Proxy/Keyframe storage', value: FEATURE_REMOTE_PROXIES },
  { label: 'Iconik Shield', value: FEATURE_ICONIK_SHIELD },
  { label: 'Search Backends', value: FEATURE_SEARCH_BACKENDS },
  {
    label: 'Natural Language To Filters',
    value: FEATURE_NATURAL_LANGUAGE_TO_FILTERS,
  },
  { label: 'Natural Search', value: FEATURE_NATURAL_SEARCH },
  {
    label: 'Natural Search Segments',
    value: FEATURE_NATURAL_SEARCH_SEGMENTS,
  },
  { label: 'AI Metadata Enrichment', value: FEATURE_AI_METADATA_ENRICHMENT },
  {
    label: 'AI Metadata Enrichment Automation',
    value: FEATURE_AI_METADATA_ENRICHMENT_AUTOMATION,
  },
  { label: 'MCP Server', value: FEATURE_MCP_SERVER },
  { label: 'CuttingRoom', value: FEATURE_CUTTING_ROOM },
  { label: 'iOS Sync', value: FEATURE_IOS_SYNC },
  {
    label: 'DRM and Forensic Watermark',
    value: FEATURE_DRM_FORENSIC_WATERMARK,
  },
  {
    label: 'Wildmoka Publish Supports Transfer and Publish',
    value: FEATURE_WM_PUBLISH_SUPPORTS_TRANSFER_AND_PUBLISH,
  },
  { label: 'Portals', value: FEATURE_PORTALS },
  { label: 'PDF Clickable Links', value: FEATURE_PDF_CLICKABLE_LINKS },
  {
    label: 'Wildmoka Replaces FFmpeg',
    value: FEATURE_WILDMOKA_REPLACES_FFMPEG,
  },
  { label: 'SCIM Provisioning', value: FEATURE_SCIM },
];
